// #region IMPORTS
import React from 'react';
import { useAppAuth } from '../Auth/authAdapter';
import azLogo from '../Assets/images/logo_short.png';
import { MdArrowBack as ArrowBack } from 'react-icons/md';
import { AZButton } from '@azmed-org/azcomponents';
import { AppBackground } from '../Components/Background';
// CSS
import './UnauthorizedLayout.css';
// #endregion

// #region COMPONENT
/**
 * @returns The page shown to a user without access, with a logout button
 */
const UnauthorizedLayout = () => {
  // #region INITIALIZATION
  // Hooks
  const { logout } = useAppAuth();
  // #endregion

  // #region INTERFACE
  return (
    <>
      <div className="Unauthorized-Container">
        <div className="Unauthorized-MainContainer">
          <div className="Unauthorized-LogoContainer">
            <img src={azLogo} alt="AZ Logo" />
          </div>
          <div className="Unauthorized-descriptionContainer">
            <h1 className="Unauthorized-title">
              Sorry but it seems you don&apos;t have access to this application.
            </h1>
            <p>
              Please contact an administrator if you believe this is an error.
            </p>
          </div>
          <div className="Unauthorized-buttonContainer">
            <AZButton
              aria-haspopup="true"
              color="inherit"
              onClick={() =>
                logout({ logoutParams: { returnTo: window.location.origin } })
              }
            >
              <ArrowBack className="AZmedNavbar-Icon" />
            </AZButton>
          </div>
        </div>
        <div className="Unauthorized-emptyContainer"></div>
      </div>
      <AppBackground />
    </>
  );
  // #endregion
};
// #endregion

export { UnauthorizedLayout };
